import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography } from '@mui/material'
import { ActivityStatusIndicator } from './ActivityStatusIndicator'

const IdleActivityIndicator: FC = () => (
  <Box sx={containerSx}>
    <Box sx={iconSlotSx}>
      <ActivityStatusIndicator status="idle" />
    </Box>
    <Typography sx={textSx}>Awaiting activity</Typography>
  </Box>
)

const containerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
}

const iconSlotSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  flexShrink: 0,
}

const textSx: SxProps<Theme> = {
  fontSize: '0.8125rem',
  fontStyle: 'italic',
  color: 'text.disabled',
}

export { IdleActivityIndicator }
